module.exports = __webpack_public_path__ + "img/u512.67860711.png";